import React from "react";
import { motion } from "framer-motion";
import { Hand } from "lucide-react";

// Text hint shown below the central wheel: "TAP THE WHEEL / +1 BERRY".
export const TapHint = ({ perClick = 1 }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ delay: 0.4, duration: 0.6 }}
    className="flex items-center gap-3 pointer-events-none select-none"
    data-testid="tap-hint"
  >
    <motion.div
      animate={{ y: [0, -3, 0] }}
      transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
      className="w-9 h-9 rounded-full flex items-center justify-center"
      style={{ border: "1.5px solid #FFD400" }}
    >
      <Hand size={16} color="#FFD400" />
    </motion.div>
    <div className="flex flex-col">
      <span
        className="text-sm sm:text-base font-black uppercase tracking-[0.35em] text-white"
        style={{ fontFamily: "Orbitron, sans-serif" }}
      >
        Tap the wheel
      </span>
      <span
        className="text-xs uppercase tracking-[0.3em]"
        style={{ color: "#FFD400", fontFamily: "Orbitron, sans-serif" }}
      >
        +{perClick} Berry
      </span>
    </div>
  </motion.div>
);

export default TapHint;
